import React, { useEffect, useState } from "react";
import axios from "axios";
import { FiFlag, FiUsers } from "react-icons/fi";
import { AiOutlineWarning, AiOutlineCheckCircle } from "react-icons/ai";
import { MdOutlineReport } from "react-icons/md";
import { FaRegEye, FaRegEdit } from "react-icons/fa";
import { GoStop } from "react-icons/go";
import ReportDetailsModal from "../components/ReportDetailsModal";
import { CgProfile } from "react-icons/cg";
import UserDetailsModal from "../components/UserDetailsModal";

const formatName = (maybeUser) => {
  if (!maybeUser) return "N/A";
  return (
    maybeUser.fullName ||
    maybeUser.name ||
    maybeUser.displayName ||
    maybeUser.email ||
    maybeUser.id ||
    maybeUser._id ||
    "N/A"
  );
};

const normalizeStatusKey = (s) => {
  if (!s) return "";
  return String(s).toUpperCase();
};

const ReportsDashboard = () => {

    // const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [blockedLoading, setBlockedLoading] = useState(true);
  const [stats, setStats] = useState({
    totalReports: 0,
    recentReports: 0,
    byStatus: {},
    byCategory: {},
  });
  const [selectedReport, setSelectedReport] = useState(null);
  const [reports, setReports] = useState([]);
  const [blockedContacts, setBlockedContacts] = useState([]);
  const [blockedStats, setBlockedStats] = useState({
    totalBlocks: 0,
    frequentlyBlocked: 0,
    uniqueBlockedUsers: 0
  });

  const [expandedUserId, setExpandedUserId] = useState(null);
const [selectedUser, setSelectedUser] = useState(null);
const [selectedUserId, setSelectedUserId] = useState(null);
const [viewModalOpen, setViewModalOpen] = useState(false);

  const [filter, setFilter] = useState("ALL");
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ currentPage: 1, totalPages: 1, totalReports: 0 });
  const [activeTab, setActiveTab] = useState("reports"); 
  const [selectedBlockedContact, setSelectedBlockedContact] = useState(null);

  useEffect(() => {
    console.log("Selected User:", selectedUser);
}, [selectedUser]);


  useEffect(() => {
    fetchReportData();
    fetchBlockedContacts();
    fetchBlockedStats();
  }, [filter, page, activeTab]);

  const openUserDetails = async (userId) => {
    try {
        const res = await axios.get(`/api/v1/app/profile/admin/view-profile-by-id/${userId}`);
 setSelectedUser(res.data.data);
        setSelectedUserId(userId);
        setViewModalOpen(true);

    } catch (err) {
        console.error(err);
    }
};

  const fetchBlockedStats = async () => {
    try {
      const res = await axios.get(
        "/api/v1/app/user-blocks/user-blocks/stats"
      );

      if (res?.data?.status === "OK") {
        setBlockedStats(res.data.data);
      }
    } catch (err) {
      console.error("Error fetching blocked stats", err);
    }
  };


  const fetchReportData = async () => {
    try {
      setLoading(true);

      const [countsRes, reportsRes] = await Promise.all([
        axios.get("/api/v1/app/user-reports/counts"),
        axios.get("/api/v1/app/user-reports", {
          params: {
            status: filter !== "ALL" ? filter : undefined,
            page,
            limit: 20
          }
        })
      ]);


      if (countsRes?.data?.status === "OK") {
        const c = countsRes.data.data;

        setStats({
          totalReports: c.totalReports || 0,
          recentReports: c.pendingReports || 0, // used as "Pending"
          byStatus: {
            PENDING: c.pendingReports || 0,
            UNDER_REVIEW: c.underReviewReports || 0,
            RESOLVED: c.resolvedReports || 0,
            DISMISSED: c.dismissedReports || 0
          },
          byCategory: {} // not needed for this API
        });
      }


      /* ---------- REPORTS ---------- */
      if (reportsRes?.data?.status === "OK") {
        const d = reportsRes.data.data;

        setReports(d.reports || []);
        setPagination(d.pagination || {});
      }
    } catch (err) {
      console.error("Admin report fetch failed", err);
    } finally {
      setLoading(false);
    }
  };

  
    const mapUserToModalData = (user) => {
        if (!user) return null;

        return {
            name: user.fullName || '-',
            email: user.email || '-',
            phone: user.phoneNumber || '-',
            address: user.city || '-',
            latitude: user.coordinates.latitude || '-',
            longitude: user.coordinates.longitude || '-',
            age: calculateAge(user.dateOfBirth) || '-',
            dob: user.dateOfBirth ? new Date(user.dateOfBirth).toLocaleDateString() : '-',
            gender: user.gender || '-',
            role: user.role || '-',
            lastActive: user.lastActive ? new Date(user.lastActive).toLocaleString() : '-',
            accountCreated: user.createdAt ? new Date(user.createdAt).toLocaleString() : '-',
            followers: user.followers ? user.followers.length : 0,
            following: user.following ? user.following.length : 0,
            friends: user.friends ? user.friends.length : 0,
            networkConnections: (user.followers?.length || 0) + (user.following?.length || 0),
            lastActiveDate: user.lastActive ? new Date(user.lastActive).toLocaleDateString() : '-',
            lastActiveTime: user.lastActive ? new Date(user.lastActive).toLocaleTimeString() : '-',
            image: user.profileImage || 'https://via.placeholder.com/150'
        };
    };

       const calculateAge = (dob) => {
        if (!dob) return '-';
        const today = new Date();
        const birthDate = new Date(dob);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) age--;
        return age;
    };


      const getLocation = (user) => {
        if (user.location) return user.location;
        if (user.city && user.state && user.country) return `${user.city}, ${user.state}, ${user.country}`;
        if (user.city && user.country) return `${user.city}, ${user.country}`;
        if (user.city) return user.city;
        if (user.country) return user.country;
        return '-';
    };


  const markUnderReview = async (id) => {
    await axios.patch(`/api/v1/app/user-reports/${id}/under-review`, {
      adminNotes: "Admin started review"
    });
    fetchReportData();
  };

  const resolveReport = async (id) => {
    await axios.patch(`/api/v1/app/user-reports/${id}/resolve`, {
      action: "WARNING",
      duration: 0,
      reason: "Violation confirmed",
      adminNotes: "Resolved from admin panel"
    });
    fetchReportData();
  };

  const dismissReport = async (id) => {
    await axios.patch(`/api/v1/app/user-reports/${id}/dismiss`, {
      reason: "No policy violation",
      adminNotes: "Dismissed by admin"
    });
    fetchReportData();
  };






  const fetchBlockedContacts = async () => {
    try {
      setBlockedLoading(true);

      const res = await axios.get(
        "/api/v1/app/user-blocks/users-with-blocks"
      );

      if (res?.data?.success) {
        setBlockedContacts(res.data.data || []);
      }
    } catch (err) {
      console.error("Error fetching blocked contacts", err);
      setBlockedContacts([]);
    } finally {
      setBlockedLoading(false);
    }
  };



  const totalReports = stats.totalReports ?? 0;

  const filteredReports =
    filter === "ALL"
      ? reports
      : reports.filter((r) => normalizeStatusKey(r.status) === normalizeStatusKey(filter));

  
  const blockedCountMap = {};

  blockedContacts.forEach(block => {
    const blockedUserId = block.blocked?._id;
    if (blockedUserId) {
      blockedCountMap[blockedUserId] = (blockedCountMap[blockedUserId] || 0) + 1;
    }
  });

  const frequentlyBlockedUsers = Object.keys(blockedCountMap).filter(
    userId => blockedCountMap[userId] >= 3
  );



  return (
    <div className="min-h-screen p-6 bg-white text-[var(--black-text)] max-w-full overflow-x-hidden">
      {/* Tabs */}
      <div className="mb-6 flex gap-4 border-b-2 border-gray-200">
        <button
          onClick={() => setActiveTab("reports")}
          className={`px-6 py-3 font-semibold transition ${activeTab === "reports"
              ? "border-b-2 border-[var(--primary-solid)] text-[var(--primary-solid)]"
              : "text-[var(--black-text)]/70 hover:text-[var(--primary-solid)]"
            }`}
        >
          User Reports
        </button>
        <button
          onClick={() => setActiveTab("blocked")}
          className={`px-6 py-3 font-semibold transition ${activeTab === "blocked"
              ? "border-b-2 border-[var(--primary-solid)] text-[var(--primary-solid)]"
              : "text-[var(--black-text)]/70 hover:text-[var(--primary-solid)]"
            }`}
        >
          Blocked Contacts
        </button>
      </div>

      {activeTab === "reports" && (
        <div>
          {/* Top stat cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
            <div className="bg-gradient-to-br from-red-500/10 to-red-500/5 border-2 border-red-500/20 rounded-xl p-4 shadow-lg">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs font-medium text-red-400 uppercase tracking-wider">
                    Pending Reports
                  </p>
                  <p className="text-2xl font-bold text-red-400">
                    {stats.byStatus?.PENDING ?? stats.byStatus?.pending ?? 0}
                  </p>
                </div>
                <div className="text-3xl text-red-400">
                  <AiOutlineWarning />
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-green-500/10 to-green-500/5 border-2 border-green-500/20 rounded-xl p-4 shadow-lg">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs font-medium text-green-400 uppercase tracking-wider">
                    Resolved Reports
                  </p>
                  <p className="text-2xl font-bold text-green-400">
                    {stats.byStatus?.RESOLVED ?? stats.byStatus?.resolved ?? 0}
                  </p>
                </div>
                <div className="text-3xl text-green-400">
                  <AiOutlineCheckCircle />
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-blue-500/10 to-blue-500/5 border-2 border-blue-500/20 rounded-xl p-4 shadow-lg">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs font-medium text-blue-400 uppercase tracking-wider">
                    Total Reports
                  </p>
                  <p className="text-2xl font-bold text-blue-400">
                    {totalReports}
                  </p>
                </div>
                <div className="text-3xl text-blue-400">
                  <MdOutlineReport />
                </div>
              </div>
            </div>
          </div>

          {/* Reports management card */}
          <div className="rounded-lg p-6 border-2 border-gray-200 bg-white shadow-sm">
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className="text-2xl">
                  <FiFlag className="text-[var(--primary-solid)]" />
                </div>
                <h2 className="text-xl font-semibold text-[var(--primary-solid)]">Reports Management</h2>
              </div>

              <div>
                <select
                  value={filter}
                  onChange={(e) => setFilter(e.target.value)}
                  className="border-2 border-gray-200 rounded-md px-3 py-2 bg-white text-[var(--black-text)] focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)]"
                >
                  <option className="bg-white text-[var(--black-text)]" value="ALL">All Reports</option>
                  <option className="bg-white text-[var(--black-text)]" value="PENDING">Pending</option>
                  <option className="bg-white text-[var(--black-text)]" value="UNDER_REVIEW">Under Review</option>
                  <option className="bg-white text-[var(--black-text)]" value="RESOLVED">Resolved</option>
                  <option className="bg-white text-[var(--black-text)]" value="DISMISSED">Dismissed</option>
                </select>
              </div>
            </div>



            {/* Table header */}
            <div className="overflow-x-auto overflow-y-auto max-h-[500px] bg-white rounded-2xl shadow-lg border-2 border-gray-200 w-full">
              <table className="w-full text-sm text-[var(--black-text)] min-w-[800px]">
                <thead>
                  <tr className="bg-[var(--yellow)] text-white text-xs uppercase font-semibold">
                    <th className="py-3 px-2 bg-[var(--yellow)] text-white text-xs">Report ID</th>
                    <th className="py-3 px-2 bg-[var(--yellow)] text-white text-xs">Reporter</th>
                    <th className="py-3 px-2 bg-[var(--yellow)] text-white text-xs">Reported User</th>
                    <th className="py-3 px-2 bg-[var(--yellow)] text-white text-xs">Reason</th>
                    <th className="py-3 px-2 bg-[var(--yellow)] text-white text-xs">Status</th>
                    <th className="py-3 px-2 bg-[var(--yellow)] text-white text-xs">Created</th>
                    <th className="py-3 px-2 bg-[var(--yellow)] text-white text-xs">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {loading ? null : filteredReports.length > 0 ? (
                    filteredReports.map((r) => {
                      const id = r.id || r._id || r.reportId || "—";
                      const reporter =
                        r.reporterUser || r.reporter || r.reporterId || r.reporterId?.user || r.reporterUserId;
                      const reportedUser =
                        r.reportedUser || r.reported || r.reportedUserId || r.reportedUserId?.user || r.reported;
                      const reason = r.reason || r.category || r.categoryName || "—";
                      const status = r.status || r.currentStatus || "PENDING";

                      // status display using yellow-only scheme
                      const statusLabel = String(status).replace(/_/g, " ");
                      const statusBadge = (
                        <span className="px-2 py-1 rounded text-xs font-medium bg-[var(--yellow)] text-[var(--black)]">
                          {statusLabel}
                        </span>
                      );

                      return (
                        <tr key={id} className="border-b last:border-0 border-gray-200 hover:bg-gray-50">
                          <td className="py-3 px-2 text-center text-[var(--black-text)] text-xs">{String(id)}</td>
                          {/* <td className="py-3 px-2 text-center text-[var(--black-text)] text-xs truncate max-w-[150px]">{formatName(reporter)}</td> */}
                          <td className="text-center">
   <button
    className="text-blue-600 hover:underline"
    onClick={() => {
        if (!reporter?._id) return;

        openUserDetails(reporter._id);
    }}
>
    {formatName(reporter)}
</button>
</td>
                          {/* <td className="py-3 px-2 text-center text-[var(--black-text)] text-xs truncate max-w-[150px]">{formatName(reportedUser)}</td> */}

<td className="text-center">
<button
    className="text-blue-600 hover:underline"
    onClick={() => {
        if (!reportedUser?._id) return;

        openUserDetails(reportedUser._id);
    }}
>
    {formatName(reportedUser)}
</button>
</td>

                          <td className="py-3 px-2 text-center text-[var(--black-text)]/70 text-xs truncate max-w-[120px]">{reason}</td>
                          <td className="py-3 px-2 text-center">{statusBadge}</td>
                          <td className="py-3 px-2 text-center text-[var(--black-text)]/70 text-xs whitespace-nowrap">
                            {r.createdAt ? new Date(r.createdAt).toLocaleString() : r.updatedAt ? new Date(r.updatedAt).toLocaleString() : "—"}
                          </td>
                          <td className="py-3 px-2 text-center">
                            <div className="flex items-center justify-center gap-1 flex-wrap">
                              <button
                                onClick={() => setSelectedReport(r)}
                                className="flex items-center gap-1 text-xs hover:text-[var(--primary-solid)]"
                                title="View"
                              >
                                <FaRegEye /> View
                              </button>
 <td className="p-3">


                    </td>
                            
                              {status === "PENDING" && (
                                <button
                                  onClick={() => markUnderReview(id)}
                                  className="text-xs text-blue-600 hover:underline"
                                >
                                  Review
                                </button>
                              )}

                              {status === "UNDER_REVIEW" && (
                                <>
                                  <button
                                    onClick={() => resolveReport(id)}
                                    className="text-xs text-green-600 hover:underline"
                                  >
                                    Resolve
                                  </button>
                                  <button
                                    onClick={() => dismissReport(id)}
                                    className="text-xs text-red-600 hover:underline"
                                  >
                                    Dismiss
                                  </button>
                                </>
                              )}

                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={7} className="py-16">
                        <div className="flex flex-col items-center justify-center gap-3">
                          <div className="w-16 h-16 rounded-md bg-[var(--primary-solid)]/10 flex items-center justify-center border-2 border-gray-200">
                            <FiFlag className="text-[var(--primary-solid)] text-2xl" />
                          </div>
                          <div className="text-lg font-semibold text-[var(--primary-solid)]">No reports found</div>
                          <div className="text-sm text-[var(--black-text)]/70">No reports have been submitted yet.</div>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* pagination footer */}
            <div className="mt-6 flex items-center justify-between">
              <div className="text-sm text-[var(--black-text)]/70">
                Showing {filteredReports.length} of {pagination.totalReports || totalReports} reports
              </div>

              <div className="flex items-center gap-2">
                <button
                  onClick={() => {
                    if (pagination.currentPage > 1) {
                      setPage((p) => p - 1);
                    }
                  }}
                  className="px-3 py-1 border-2 border-gray-200 rounded disabled:opacity-50 text-[var(--black-text)] hover:bg-gradient-to-r hover:from-[var(--primary-solid)] hover:to-[var(--primary-dark)] hover:text-white"
                  disabled={pagination.currentPage <= 1}
                >
                  Prev
                </button>

                <div className="text-sm text-[var(--black-text)]">Page {pagination.currentPage} / {pagination.totalPages}</div>

                <button
                  onClick={() => {
                    if (pagination.currentPage < pagination.totalPages) {
                      setPage((p) => p + 1);
                    }
                  }}
                  className="px-3 py-1 border-2 border-gray-200 rounded disabled:opacity-50 text-[var(--black-text)] hover:bg-gradient-to-r hover:from-[var(--primary-solid)] hover:to-[var(--primary-dark)] hover:text-white"
                  disabled={pagination.currentPage >= pagination.totalPages}
                >
                  Next
                </button>
              </div>
            </div>
          </div>

          {selectedReport && (
            <ReportDetailsModal
              report={selectedReport}
              onClose={() => setSelectedReport(null)}
            />
          )}
        </div>
      )}

      {activeTab === "blocked" && (
        <div>
          {/* Blocked Contacts Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
            <div className="bg-gradient-to-br from-red-500/10 to-red-500/5 border-2 border-red-500/20 rounded-xl p-4 shadow-lg">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs font-medium text-red-400 uppercase tracking-wider">
                    Total Blocks
                  </p>
                  <p className="text-2xl font-bold text-red-400">
                    {blockedStats.totalBlocks}
                  </p>
                </div>
                <div className="text-3xl text-red-400">
                  <GoStop />
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-orange-500/10 to-orange-500/5 border-2 border-orange-500/20 rounded-xl p-4 shadow-lg">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs font-medium text-orange-400 uppercase tracking-wider">
                    Frequently Blocked
                  </p>
                  <p className="text-2xl font-bold text-orange-400">
                    {blockedStats.frequentlyBlocked}
                  </p>
                </div>
                <div className="text-3xl text-orange-400">
                  <AiOutlineWarning />
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-purple-500/10 to-purple-500/5 border-2 border-purple-500/20 rounded-xl p-4 shadow-lg">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs font-medium text-purple-400 uppercase tracking-wider">
                    Unique Blocked Users
                  </p>
                  <p className="text-2xl font-bold text-purple-400">
                    {blockedStats.uniqueBlockedUsers}
                  </p>
                </div>
                <div className="text-3xl text-purple-400">
                  <FiUsers />
                </div>
              </div>
            </div>
          </div>

          {/* Blocked Contacts Table */}
          <div className="rounded-lg p-6 border-2 border-gray-200 bg-white shadow-sm">
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className="text-2xl">
                  <GoStop className="text-[var(--primary-solid)]" />
                </div>
                <h2 className="text-xl font-semibold text-[var(--primary-solid)]">Blocked Contacts</h2>
              </div>
            </div>

            {blockedLoading ? (
              <div className="flex justify-center items-center py-12">
                <div className="w-10 h-10 border-4 border-gray-200 border-t-[var(--primary-solid)] rounded-full animate-spin" />
              </div>
            ) : (
              <div className="overflow-x-auto overflow-y-auto max-h-[500px] bg-white rounded-2xl shadow-lg border-2 border-gray-200 w-full">
                <table className="w-full text-sm text-[var(--black-text)] min-w-[800px]">
                  <thead>
                    <tr className="bg-[var(--yellow)] text-white text-xs uppercase font-semibold">
                      <th className="py-3 px-4">User</th>
                      <th className="py-3 px-4">Blocked Count</th>
                      <th className="py-3 px-4">Action</th>
                    </tr>
                  </thead>


                  
                  <tbody>
                    {blockedContacts.length > 0 ? (
                      blockedContacts.map((user) => {
                        const isExpanded = expandedUserId === user._id;

                        return (
                          <React.Fragment key={user._id}>
                            {/* MAIN USER ROW */}
                            <tr className="border-b hover:bg-gray-50">
                              <td className="py-3 text-center font-semibold">
                                <div className="flex flex-col">
                                  <span>{user.fullName}</span>
                                  <span className="text-xs text-gray-500">{user.phoneNumber}</span>
                                </div>
                              </td>

                              <td className="py-3 text-center">
                                <span
                                  className={`px-2 py-1 rounded text-xs font-medium ${user.blockedCount >= 3
                                      ? "bg-red-500 text-white"
                                      : user.blockedCount >= 1
                                        ? "bg-yellow-500 text-white"
                                        : "bg-gray-200 text-gray-700"
                                    }`}
                                >
                                  {user.blockedCount}
                                </span>
                              </td>

                              <td className="py-3 text-center">
                                {user.blockedCount > 0 ? (
                                  <button
                                    onClick={() =>
                                      setExpandedUserId(isExpanded ? null : user._id)
                                    }
                                    className="px-3 py-1 text-xs rounded bg-blue-500 text-white hover:bg-blue-600"
                                  >
                                    {isExpanded ? "Hide" : "View"}
                                  </button>
                                ) : (
                                  <span className="text-gray-400 text-xs">No Blocks</span>
                                )}
                              </td>
                            </tr>

                            {/* EXPANDED BLOCKED USERS LIST */}
                            {isExpanded &&
                              user.blockedUsers.map((b) => {
                                const blockedUser = user.blockedUsersData.find(
                                  (u) => u._id === b._id
                                );

                                return (
                                  <tr key={b._id} className="bg-gray-50 border-b">
                                    <td className="py-3 pl-10 text-sm text-left">
                                      <div className="flex items-center gap-3">
                                        <img
                                          src={
                                            blockedUser?.profileImage ||
                                            "https://via.placeholder.com/40"
                                          }
                                          alt=""
                                          className="w-8 h-8 rounded-full object-cover"
                                        />
                                        <div>
                                          <div className="font-medium">
                                            {blockedUser?.fullName || "Unknown"}
                                          </div>
                                          <div className="text-xs text-gray-500">
                                            {blockedUser?.phoneNumber || ""}
                                          </div>
                                        </div>
                                      </div>
                                    </td>

                                    <td className="py-3 text-center text-sm text-red-600">
                                      {b.reason}
                                    </td>

                                    <td className="py-3 text-center text-xs text-gray-500">
                                      {b.blockedAt
                                        ? new Date(b.blockedAt).toLocaleString()
                                        : "—"}
                                    </td>
                                  </tr>
                                );
                              })}
                          </React.Fragment>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={3} className="py-10 text-center text-gray-500">
                          No blocked users found
                        </td>
                      </tr>
                    )}
                  </tbody>

                </table>
              </div>
            )}
          </div>

          {/* Blocked Contact Details Modal */}
          {selectedBlockedContact && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 max-h-[90vh] overflow-y-auto">
                <div className="p-6 border-b border-gray-200">
                  <div className="flex items-center justify-between">
                    <h3 className="text-xl font-bold text-[var(--primary-solid)]">Blocked User Details</h3>
                    <button
                      onClick={() => setSelectedBlockedContact(null)}
                      className="text-gray-400 hover:text-gray-600 text-2xl"
                    >
                      ×
                    </button>
                  </div>
                </div>

                <div className="p-6">
                  {(() => {
                    const block = selectedBlockedContact;
                    const blocker = block.blockerUserId?.user || block.blockerUserId || block.blocker || block.blockerUser;
                    const blockedUser = block.blockedUserId?.user || block.blockedUserId || block.blocked || block.blockedUser;
                    const blockedUserId = block.blockedUserId?._id || block.blockedUserId?.id || block.blockedUserId || block.blockedUser?._id || block.blockedUser?.id || block.blockedUser;
                    const blockCount = blockedUserId ? blockedCountMap[blockedUserId] || 1 : 1;
                    const isFrequentlyBlocked = frequentlyBlockedUsers.includes(blockedUserId);

                    return (
                      <div className="space-y-4">
                        <div className="flex items-center justify-between w-full">
                          <div className="text-left">
                            <p className="text-sm font-medium text-gray-500 block">Blocked User</p>
                            <p className="text-lg font-semibold text-[var(--black-text)] mt-1 block">{formatName(blockedUser)}</p>
                          </div>

                          <div className="flex items-center gap-6">
                            <div className="text-center">
                              <p className="text-sm font-medium text-gray-500">Block Count</p>
                              <span className={`inline-block px-3 py-1 rounded-full text-sm font-medium mt-1 ${blockCount >= 3
                                  ? "bg-red-500 text-white"
                                  : blockCount >= 2
                                    ? "bg-yellow-500 text-white"
                                    : "bg-gray-200 text-gray-700"
                                }`}>
                                {blockCount} {blockCount === 1 ? "time" : "times"}
                              </span>
                            </div>
                            <div className="text-center">
                              <p className="text-sm font-medium text-gray-500">Status</p>
                              <span className="inline-block px-3 py-1 rounded-full text-sm font-medium bg-gray-200 text-gray-700 mt-1">
                                Active
                              </span>
                            </div>
                          </div>
                        </div>

                        {isFrequentlyBlocked && (
                          <div className="bg-red-50 border border-red-200 rounded-lg p-3">
                            <div className="flex items-center gap-2">
                              <span className="text-red-500 text-lg">⚠️</span>
                              <div>
                                <p className="font-medium text-red-800">High Risk User</p>
                                <p className="text-sm text-red-600">This user has been blocked by multiple users</p>
                              </div>
                            </div>
                          </div>
                        )}

                        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                          <div className="grid grid-cols-3 gap-4">
                            {/* Headers Row */}
                            <div className="text-center">
                              <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Blocked By</p>
                            </div>
                            <div className="text-center">
                              <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Reason</p>
                            </div>
                            <div className="text-center">
                              <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Date & Time</p>
                            </div>

                            {/* Values Row */}
                            <div className="text-center">
                              <p className="text-sm font-semibold text-[var(--black-text)] mt-2">{formatName(blocker)}</p>
                            </div>
                            <div className="text-center">
                              <p className="text-sm text-[var(--black-text)] mt-2">{block.reason || "Not specified"}</p>
                            </div>
                            <div className="text-center">
                              <p className="text-sm text-[var(--black-text)] mt-2">
                                {block.createdAt
                                  ? new Date(block.createdAt).toLocaleString()
                                  : block.blockedAt
                                    ? new Date(block.blockedAt).toLocaleString()
                                    : "Date not available"}
                              </p>
                            </div>
                          </div>
                        </div>

                        {/* Show other users who have blocked this same user */}
                        {blockedUserId && blockCount > 1 && (
                          <div className="border-t pt-4">
                            <p className="text-sm font-medium text-gray-500 mb-2">
                              Also blocked by {blockCount - 1} other user{blockCount - 1 !== 1 ? 's' : ''}:
                            </p>
                            <div className="space-y-2 max-h-32 overflow-y-auto">
                              {blockedContacts
                                .filter(b => {
                                  const bId = b.blockedUserId?._id || b.blockedUserId?.id || b.blockedUserId || b.blockedUser?._id || b.blockedUser?.id || b.blockedUser;
                                  return bId === blockedUserId && b._id !== block._id;
                                })
                                .slice(0, 5) // Show max 5 other blockers
                                .map((otherBlock, idx) => {
                                  const otherBlocker = otherBlock.blockerUserId?.user || otherBlock.blockerUserId || otherBlock.blocker || otherBlock.blockerUser;
                                  return (
                                    <div key={idx} className="flex items-center justify-between bg-gray-50 p-2 rounded">
                                      <span className="text-sm text-[var(--black-text)]">{formatName(otherBlocker)}</span>
                                      <span className="text-xs text-gray-500">
                                        {otherBlock.createdAt
                                          ? new Date(otherBlock.createdAt).toLocaleDateString()
                                          : "Date unknown"}
                                      </span>
                                    </div>
                                  );
                                })}
                              {blockCount > 6 && (
                                <p className="text-xs text-gray-500 text-center">
                                  ...and {blockCount - 6} more
                                </p>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })()}
                </div>

                <div className="p-6 border-t border-gray-200 flex justify-end gap-3">
                  <button
                    onClick={() => setSelectedBlockedContact(null)}
                    className="px-4 py-2 border border-gray-300 rounded-lg text-[var(--black-text)] hover:bg-gray-50"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

{viewModalOpen && selectedUser && (
    <UserDetailsModal
        model={mapUserToModalData(selectedUser)}
        onClose={() => {
            setViewModalOpen(false);
            setSelectedUser(null);
            setSelectedUserId(null);
        }}
        userId={selectedUserId}
    />
)}
    </div>
  );
};

export default ReportsDashboard;

